module.exports = __webpack_public_path__ + "assets/c7b19e5a9f05ea332f11e4335a7af1d4.png";